module.exports = __webpack_public_path__ + "static/img/14.cda2fc5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/9/zh/14.png
// module id = BToy
// module chunks = 0